import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { AuthService } from "@services";
import { Observable, map } from "rxjs";

@Injectable({ providedIn: "root" })
export class LoggedInAuthGuard implements CanActivate {
  constructor(
    private _authService: AuthService,
    private _router: Router,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this._authService.isAuthenticated().pipe(
      map((isAuthenticated) => {
        if (isAuthenticated) {
          const extras =
            "emailVerificationCallback" in route.queryParams
              ? { queryParams: { emailVerificationCallback: true } }
              : {};
          this._router.navigate(["/dashboard"], extras);
          return false;
        }
        return true;
      }),
    );
  }
}
